export enum RequestStageEnum {
  Pending = 1,
  Accepted,
  ProjectPending,
  ProjectApproved,
  ContractReceived,
  Payment,
  Permit,
  WorkRequest,
  Completed,
  Denied,
  ContractRejected,
  ProjectCancelled
}

export enum RequestStageApprvEnum {
  APPPEND = 1,
  APPACCPT,
  PEND,
  APPRVD,
  CONRCVD,
  PMNT,
  PRMT,
  WRCS,
  COMP,
  APPDENIED,
  CONRJTD,
  CNCL
}

export enum RequestStageLabelEnum {
  Pending = 'Application Pending',
  Accepted = 'Application Accepted',
  ProjectPending = 'Project Pending',
  ProjectApproved = 'Project Approved',
  ContractReceived = 'Contract Received',
  Payment = 'Payment',
  Permit = 'Permit',
  WorkRequest = 'WR Created and Scheduled',
  Completed = 'Project Completed',
  Denied = 'Application Denied',
  ContractRejected = 'Contract Rejected',
  ProjectCancelled = 'Project Cancelled',

}

export enum RequestStatusEnum {
  ApplicationPending = 'APPPEND',
  ApplicationAccepted = 'APPACCPT',
  ApplicationDenied = 'APPDENIED',
  ProjectApproved = 'APPRVD	',
  ProjectPending = 'PEND',
  Assigned = 'ASSGND',
  ContractReceived = 'CONRCVD',
  Payment = 'PMNT',
  Permit = 'PRMT',
  WRCreated = 'WRCS',
  Completed = 'COMP',
  ContractRejected = 'CONRJTD'
}
